"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 23.5 22';

var Home = function Home() {
  return _react["default"].createElement("path", {
    strokeWidth: "0.002",
    d: "M11.6398164,1.96564329 C11.518369,1.96823079 11.4050629,2.00820193 11.2961356,2.08244021 L0.298348867,10.7074523 C0.045315957,10.9093062 0.0094168658,11.2818201 0.198862309,11.5250164 C0.385581575,11.764734 0.782749278,11.8031153 1.02188747,11.6148602 L11.6579049,3.27736257 L22.2939223,11.6148602 C22.5330605,11.8031153 22.9193057,11.7632678 23.1079033,11.5250164 C23.2950856,11.2885476 23.2749596,10.8957362 23.0174609,10.7074523 L12.0196742,2.08244021 C11.8908525,1.99813655 11.7612638,1.96312766 11.6398164,1.96564329 Z M4.42251889,8.57801993 L3.26485713,9.58100496 L3.26485713,19.7300861 C3.26488908,20.0810811 3.52402178,20.36561 3.84368801,20.365645 L9.34258138,20.365645 C9.66224761,20.36561 9.92138031,20.0810811 9.92141226,19.7300861 L9.92141226,14.010056 L13.3943975,14.010056 L13.3943975,19.7300861 C13.3944295,20.0810811 13.6535622,20.36561 13.9732284,20.365645 L19.4721218,20.365645 C19.791788,20.36561 20.0509207,20.0810811 20.0509527,19.7300861 L20.0509527,9.58100496 L18.8932909,8.57801993 L18.8932909,19.0945272 L14.5520593,19.0945272 L14.5520593,13.3744971 C14.5520274,13.0235022 14.2928947,12.7389733 13.9732284,12.7389382 L9.34258138,12.7389382 C9.02291514,12.7389733 8.76378244,13.0235022 8.7637505,13.3744971 L8.7637505,19.0945272 L4.42251889,19.0945272 L4.42251889,8.57801993 L4.42251889,8.57801993 Z"
  });
};

var svgProps = {
  enableStroke: true,
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(Home, svgProps);

exports["default"] = _default;